import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-92a711ea"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex align-items-center justify-content-center flex-column mt-2 mb-4" }
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-2 text-black text-weight-600 text-center" }, "\n        お仕事の確定おめでとうございます！\n      ", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-white text-center" }, "check!", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-1 mb-2 text-black text-weight-600 text-center" }, "\n        事務所様へメッセージを送信しましょう\n      ", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-size-12" }, "\n        メッセージのやりとりを事前に行っておくことで、事業所様との連絡がスムーズになります。\n      ", -1))
const _hoisted_7 = { class: "mx-3" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-size-14 mb-3" }, "\n        以下のメッセージを編集して、「送信」を押すとメッセージが送信できます。\n      ", -1))
const _hoisted_9 = { class: "d-flex align-items-center justify-content-center flex-column my-4" }

import { AxiosError } from "axios";
import { computed, onBeforeMount, onMounted, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import { applicationService } from "@/app/services/ApplicationService";
import { messageService } from "@/app/services/MessageService";
import AppButton from "@/components/atoms/button/AppButton.vue";
import AppButtonOutline from "@/components/atoms/button/AppButtonOutline.vue";
import FeatherIcon from "@/components/atoms/other/FeatherIcon.vue";
import TextAreaGroup from "@/components/molecules/form/TextAreaGroup.vue";
import Header from "@/components/organisms/common/Header.vue";
import { authStore } from "@/store/auth";
import { Application } from "@/types/order/Application";
import CustomValidationObserver from "@/plugins/CustomValidationObserver.vue";
import { useLoader } from "@/utils/loader";
import { useErrorModal } from "@/utils/modal";
import { useCustomRouter } from "@/utils/router";


export default /*#__PURE__*/_defineComponent({
  __name: 'SendMessage',
  setup(__props) {

const errorModal = useErrorModal();
const loader = useLoader();
const router = useRouter();
const route = useRoute();
const customRouter = useCustomRouter();

const form = ref<CustomValidationObserver | null>(null);
const message = ref("応募させていただきました。よろしくお願いします。");
const application = ref<Application | null>(null);

onBeforeMount(async () => {
  // パス不正の場合は仕事一覧画面に遷移
  const applicationId = Number(route.params.applicationId);
  if (Number.isNaN(applicationId)) {
    await customRouter.replaceIgnoreError({ name: "Search" });
    return;
  }

  try {
    loader.show();
    application.value = await applicationService.fetchApplication(
      applicationId
    );
  } catch (e) {
    // 見つからなかった場合は仕事一覧画面に遷移
    if (e && (e as AxiosError).isAxiosError) {
      if ((e as AxiosError).response!.status === 404) {
        await customRouter.replaceIgnoreError({ name: "Search" });
        return;
      }
    }
    await errorModal.showErrorModal(e as Error);
  } finally {
    loader.hide();
  }
});

const productAssetSuffix = computed(() => authStore.productAssetSuffix);
const mascotImage = computed(() =>
  require("@/assets/svg/caikuma_send_message" +
    authStore.productAssetSuffix +
    ".svg")
);
const formValues = computed(() => ({ message: message.value }));
const orderRegisterCalendarRoute = computed(() => ({
  name: "OrdersRegisterCalendar",
  params: { applicationId: route.params.applicationId }
}));

onMounted(() => {
  form.value!.resetForm(formValues);
});

function onClickBackDetail() {
  // 案件詳細画面まで戻る（ApplicationCompleted と実装を合わせている）
  router.go(-4);
}
async function sendMessage() {
  try {
    loader.show();
    await messageService.createMessage({
      text: message.value,
      worker: authStore.user!.id,
      office: application.value!.order.office.id
    });
    await customRouter.pushIgnoreError(orderRegisterCalendarRoute.value);
  } catch (e) {
    await errorModal.showErrorModal(e as Error);
  } finally {
    loader.hide();
  }
}

return (_ctx: any,_cache: any) => {
  const _component_ValidationProvider = _resolveComponent("ValidationProvider")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Header, null, {
      left: _withCtx(() => [
        _createVNode(FeatherIcon, {
          icon: "chevron-left",
          onClick: onClickBackDetail
        })
      ]),
      default: _withCtx(() => [
        _createTextVNode("\n    メッセージ送信\n  ")
      ], undefined, true),
      _: 1
    }),
    _createTextVNode(),
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("img", {
          width: "114",
          src: mascotImage.value
        }, null, 8, _hoisted_2),
        _createTextVNode(),
        _hoisted_3
      ]),
      _createTextVNode(),
      _createElementVNode("div", {
        class: _normalizeClass(["mt-4 mb-3 pt-2 px-3 pb-3", `bg-banner${productAssetSuffix.value}`])
      }, [
        _hoisted_4,
        _createTextVNode(),
        _hoisted_5,
        _createTextVNode(),
        _hoisted_6
      ], 2),
      _createTextVNode(),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createTextVNode(),
        _createVNode(CustomValidationObserver, {
          ref_key: "form",
          ref: form,
          "initial-values": formValues.value
        }, {
          default: _withCtx(({ handleSubmit }) => [
            _createVNode(_component_ValidationProvider, {
              vid: "message",
              name: "メッセージ",
              rules: "required|max:2000"
            }, {
              default: _withCtx((validationState) => [
                _createVNode(TextAreaGroup, {
                  modelValue: message.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((message).value = $event)),
                  rows: "3",
                  "validation-state": validationState
                }, null, 8, ["modelValue", "validation-state"])
              ]),
              _: 1
            }),
            _createTextVNode(),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(AppButton, {
                class: "w-100 mt-2",
                onClick: ($event: any) => (handleSubmit(sendMessage))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("送信")
                ], undefined, true),
                _: 2
              }, 1032, ["onClick"]),
              _createTextVNode(),
              _createVNode(AppButtonOutline, {
                class: "w-100 mt-2",
                variant: "primary",
                to: orderRegisterCalendarRoute.value
              }, {
                default: _withCtx(() => [
                  _createTextVNode("スキップ")
                ], undefined, true),
                _: 1
              }, 8, ["to"])
            ])
          ]),
          _: 1
        }, 8, ["initial-values"])
      ])
    ])
  ], 64))
}
}

})